import { FlexColumn, FullContainer } from '@gorila-shared-ui/components';
import { SnackbarProvider } from 'baseui/snackbar';
import { ToasterContainer } from 'baseui/toast';
import { MapProvider } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { EXPANDED_SIDENAV_WIDTH, GPT_DETAIL_PAGE, SESSION_404_PAGE, SIDENAV_WIDTH } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { isLoggedInState, pageState, sidenavIsPinnedState } from '../../storage/app';
import { Navbar } from '../dashboard/Navbar';
import { Sidenav } from '../dashboard/Sidenav';
import EventAlarmTypesProvider from '../gpt/providers/EventAlarmTypesProvider';
import { AppProvider } from '../providers/AppProvider';
import { AuthProvider } from '../providers/AuthProvider';
import { HeadTitle } from '../shared/HeadTitle';
import PageLayout from './PageLayout';

export function GnpKmSegurosLayout() {
  const { css, theme } = useStyles();
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const page = useRecoilValue(pageState);
  const sidenavIsPinned = useRecoilValue(sidenavIsPinnedState);
  const hideSidenav = [GPT_DETAIL_PAGE.id, SESSION_404_PAGE.id].includes(page);

  const marginLeft = (() => {
    if (hideSidenav) return;
    if (sidenavIsPinned) {
      return `${EXPANDED_SIDENAV_WIDTH}px`;
    }
    return `${SIDENAV_WIDTH}px`;
  })();

  return (
    <MapProvider>
      <SnackbarProvider placement="top">
        <AuthProvider />
        <EventAlarmTypesProvider />
        <HeadTitle />
        {isLoggedIn && (
          <>
            <AppProvider />
            <FullContainer flexible>
              {!hideSidenav && <Sidenav />}
              <FlexColumn
                classNames={css({
                  flex: 1,
                  overflowX: 'hidden',
                  marginLeft: marginLeft,
                  transition: 'margin-left 0.3s ease-in-out',
                })}
                gap={0}
              >
                <Navbar />
                <PageLayout />
              </FlexColumn>
            </FullContainer>
            <ToasterContainer
              autoHideDuration={2500}
              placement="topRight"
              resetAutoHideTimerOnUpdate
              usePortal={false}
              closeable={true}
              overrides={{
                Root: {
                  style: {
                    marginTop: '64px',
                    marginRight: theme.sizing.scale400,
                  },
                },
              }}
            />
          </>
        )}
      </SnackbarProvider>
    </MapProvider>
  );
}
